import { render, staticRenderFns } from "./NavTabsTable.vue?vue&type=template&id=32017d90&"
import script from "./NavTabsTable.vue?vue&type=script&lang=js&"
export * from "./NavTabsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NavTabsTable.vue"
export default component.exports